import { CheckInVerificationStatus, ExperiencePurchaseItem, PurchaseRule } from "types";
import { RedemptionRuleTransformer } from "@/components/Product/Membership/MembershipRestrictions/MembershipRedemptionRule.transformer";
import { MemberVerificationModal } from "@/components/PurchaseModification/CheckInPurchaseGuests/MemberVerificationModal";
import { useConfirmationModal } from "@/hooks/useConfirmationModal";
import { hasCheckInWithVerificationStatus } from "@/models/Guest";

export const useMemberVerificationModal = () => {
    const { confirm, ConfirmationModal } = useConfirmationModal<CheckInVerificationStatus>(MemberVerificationModal);

    return { verifyMember: confirm, MemberVerificationModal: ConfirmationModal };
};

export const useCheckIfMemberVerificationRequired = (purchaseItem?: ExperiencePurchaseItem) => {
    const hasOrganizerRequiredRule = () => {
        if (!purchaseItem?.membershipPurchaseItem?.id) return false;
        const membershipPurchaseItem = purchaseItem?.membershipPurchaseItem;

        if (!("purchaseRuleLink" in membershipPurchaseItem)) {
            return false;
        }

        const redemptionPurchaseRule = membershipPurchaseItem?.purchaseRuleLink?.purchaseRules[0]?.purchaseRule as
            | PurchaseRule
            | undefined;

        return !!redemptionPurchaseRule && RedemptionRuleTransformer.isOrganizerRequired(redemptionPurchaseRule);
    };

    const isMemberVerificationRequired = (): boolean => {
        if (hasOrganizerRequiredRule()) {
            return !purchaseItem!.guests.some((guest) => hasCheckInWithVerificationStatus(guest));
        }

        return false;
    };

    return { isMemberVerificationRequired };
};
